import './bootstrap';

(function($){
    console.log('Layout JS loaded');

    const floatingElement = document.getElementById('floatingElement');
    const floatingToggle = document.getElementById('floatingToggle');

    // Función para alternar el estado del elemento flotante
    function toggleFloatingElement() {
        floatingElement.classList.toggle('expanded');

        // Cambiar el ícono o texto del botón si lo deseas
        const icon = floatingToggle.querySelector('span');
        if (floatingElement.classList.contains('expanded')) {
            icon.textContent = '✕';
        } else {
            icon.textContent = '🌐';
        }
    }

    // Evento click para el botón toggle
    floatingToggle.addEventListener('click', toggleFloatingElement);

    // Evento para cerrar al hacer clic fuera del elemento
    document.addEventListener('click', function(event) {
        if (!floatingElement.contains(event.target) &&
            floatingElement.classList.contains('expanded')) {
            floatingElement.classList.remove('expanded');
            floatingToggle.querySelector('span').textContent = '🌐';
        }
    });

    // Soporte para navegación con teclado (Tab)
    floatingToggle.addEventListener('keydown', function(event) {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            toggleFloatingElement();
        }
    });

    // Cerrar el elemento cuando se presiona Escape
    document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape' && floatingElement.classList.contains('expanded')) {
            floatingElement.classList.remove('expanded');
            floatingToggle.querySelector('span').textContent = '🌐';
        }
    });

    // Mejorar accesibilidad para los enlaces
    const demoLinks = document.querySelectorAll('.demo-link');
    demoLinks.forEach(link => {
        link.addEventListener('keydown', function(event) {
            if (event.key === 'Enter') {
                // Aquí puedes agregar la lógica para cuando se selecciona un enlace
                console.log('Navegando a:', this.href);
            }
        });
    });
})(window.$);
